import { useData } from "@hooks/useData";
import { IRecommendedCharts, RecommendedCharts } from "@models/RecommendedCharts";
import apiConfig from "@apiConfig";
import { components } from "@apiSchema";
import http from "@core/fetch";
import { ALL_CATEGORIES_TITLE } from "@pages/Home/components/HomeLnrCategory";
import { equalInLC } from "@datassential/platform-ui-lib";
import { useCallback, useRef } from "react";

type Response = components["schemas"]["MacAndMenuTrendDataViewModelChainPermissionWrapper"];

export function useHomeCategoryRecommendedCharts(categoryName: string) {
    const requestRef = useRef<any>(null);

    const fetchFn = useCallback(
        async (name: string): Promise<IRecommendedCharts> => {
            if (requestRef.current) requestRef.current.abort();

            const isGeneralCategory = equalInLC(name, ALL_CATEGORIES_TITLE) || !name.trim();
            const method: keyof typeof apiConfig = isGeneralCategory
                ? 'get home all category reports'
                : 'get home category recommended charts'
            ;
            const queryParams = isGeneralCategory
                ? undefined
                : { text: name }
            ;

            try {
                requestRef.current = http.getXHR(method, queryParams);
                const result: Response = await requestRef.current;

                return new RecommendedCharts({
                    apiModel: result,
                    searchQuery: name,
                    randomize: isGeneralCategory,
                });
            } catch {
                return new RecommendedCharts();
            }
        },
        []
    );

    return useData(
        new RecommendedCharts(),
        fetchFn,
        categoryName
    );
}
